/**
 * Contact Sub Types Service for Outlook Add-in
 * Handles contact sub types data fetching from DoNexus API
 */

import apiClient from '../utils/apiClient';

class ContactSubTypesService {
  /**
   * Get all contact sub types with pagination, filtering, and sorting
   * @param {Object} filters - Optional filters object
   * @param {Object} options - Optional pagination options
   * @returns {Promise<Object>} Paginated response of contact sub types
   */
  async getAll(filters = {}, options = {}) {
    try {
      const queryParams = new URLSearchParams();

      // Add pagination parameters
      if (options.page) queryParams.append('page', options.page.toString());
      if (options.limit) queryParams.append('limit', options.limit.toString());

      // Add filter parameters
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });

      const queryString = queryParams.toString();
      const endpoint = queryString ? `/contact-sub-types?${queryString}` : '/contact-sub-types';
      
      const response = await apiClient.get(endpoint);
      
      if (response.success) {
        return {
          success: true,
          data: response.data,
          message: response.message
        };
      } else {
        throw new Error(response.message || 'Failed to fetch contact sub types');
      }
    } catch (error) {
      console.error('Error fetching contact sub types:', error);
      throw error;
    }
  }
}

// Create singleton instance
const contactSubTypesService = new ContactSubTypesService();

export default contactSubTypesService;


